import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class SegmentsService {

  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }
  addSegment(segment: any, highWayId: string) {
    return this.http.post(`${this.baseUrl}/v1/entity`, { ...segment })
  }

  // getSegements(
  //   pageIndex: number,
  //   sortDirection?: string,
  //   sortProperty?: string,) {

  //   const params = new HttpParams().set('page', pageIndex?.toString() || '0')
  //     .set('size', '10')
  //     .set('sortField', sortProperty || '')
  //     .set('sortDirection', sortDirection || '')
  //   return this.http.get(`${this.baseUrl}/v1/entity`, { params })
  // }

  getSegmentsHighways(pageIndex: number,
    pageSize: any,
    contratoId: any,
    idRodoviaAbrangida: any,
    sortDirection?: string,
    sortProperty?: string,
    name?: string,
    description?: string,
  ) {

    const params = new HttpParams().set('page', pageIndex?.toString() || '0')
      .set('size', pageSize || '10')
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
      .set('name', name || '')
      .set('description', description || '')
    return this.http.get(`${this.baseUrl}/v1/contracts/${contratoId}/highways-covered/${idRodoviaAbrangida}/segments`,
      { params })
  }
  getHistorySegmentos(contractId: string | null, highwayId: string | null, segmentId: string | null, pageIndex:number = 0, startDate: string | '', endDate: string | ''){
    return this.http.get(this.baseUrl + `/v1/contracts/${contractId}/highways-covered/${highwayId}/segments/${segmentId}/history?page=${pageIndex}&size=10&sortField=data&sortDirection=desc&startDate=${startDate}&endDate=${endDate}`);
  }
  vinculateSegmentToHighway(data: any, contractId: any, highWayId: any) {
    return this.http.post(`${this.baseUrl}/v1/contracts/${contractId}/highways-covered/${highWayId}/segments`,
      { ...data })
  }
  editSegment(data: any, contractId: any, highWayId: any, idSegmento: any) {
    return this.http.put(`${this.baseUrl}/v1/contracts/${contractId}/highways-covered/${highWayId}/segments/${idSegmento}`,
      { ...data })
  }
  deleteSegment(idSegmento: any, contratoId: any, idRodoviaAbrangida: any) {
    return this.http.delete(`${this.baseUrl}/v1/contracts/${contratoId}/highways-covered/${idRodoviaAbrangida}/segments/${idSegmento}`)
  }
} 
